module.exports = __webpack_public_path__ + "assets/img/thumb-logitech-landingpage-and-website.c5ec8418.jpg";